import type { AnySchema } from 'yup'

export const INVALID_NUMBER_MESSAGE = '1以上にしてください'

export const createSimpleValidation =
  (schema: AnySchema, transform?: (value: unknown) => unknown) =>
  (value: unknown): string | undefined => {
    try {
      const argValue = transform !== undefined ? transform(value) : value
      schema.validateSync(argValue)
    } catch (err) {
      if (process.env.NODE_ENV === 'development') {
        console.log(err)
      }
      return (err as Error).message
    }
  }

export const fieldNameWithParent = (field: string, parentPath: string): string => {
  return `${parentPath}.${field}`.replace(/^\.+/, '')
}
